import React from "react";
import DesktopContainer from "./DesktopContainer";
import MobileContainer from "./MobileContainer";
export default function RoadmapLayout() {
  return (
    <div
      className=" w-full flex flex-col items-center justify-center font-Helvetica text-white 
    xl:scale-[0.85] xl:translate-y-0
    lg:scale-[0.65] lg:-translate-y-10
    max-[400px]:scale-[0.8] max-[400px]:-translate-y-32
    lg:pt-0 pt-32"
    >
      <div className="w-full text-center text-4xl lg:text-6xl font-Red-Undead xl:pt-32 mb-20 uppercase">
        Roadmap
      </div>
      <DesktopContainer />
      <MobileContainer />
    </div>
  );
}
